export default function AddIcon({ color }: { color?: string }) {
  const resolvedColor = color || "white";

  return (
    <svg
      width="14"
      height="12"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.8125 9H15.1875M9 2.8125V15.1875"
        stroke={resolvedColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
